export default __webpack_public_path__ + "static/media/img-story@2x.aa4043e8.jpeg";